import { render, staticRenderFns } from "./AuthenticateTransferAuthorizerComponent.vue?vue&type=template&id=5ce245d6&scoped=true&"
import script from "./AuthenticateTransferAuthorizerComponent.vue?vue&type=script&lang=js&"
export * from "./AuthenticateTransferAuthorizerComponent.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticateTransferAuthorizerComponent.vue?vue&type=style&index=0&id=5ce245d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce245d6",
  null
  
)

export default component.exports